import { Box } from "@mui/material";

import { useEffect, useState } from "react";

//import PolicyUpdateForm from "./form";
import { AccountsandFinanceurl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { FixedAssetsCategoriesColumns } from "../../../../data/DynamicTable/Collumns";
import { fixedAssetsCategories } from "../../../../data/Columns/Queries/FixedAssetManagement/fixedAssetsmanagement";
import FixedAssetCategoryForm from "./form";

const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Fixed Assets Categories",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "id",
     inputObjectName: "activateDeactivateReceipts",
     required: "id"
  },
  showStatus: true,
};
function FixedAssetsCategories() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Fixed Assets Categories"
          subtitle="View all fixed assets categories, add and edit"
          columns={FixedAssetsCategoriesColumns}
          FormComponent={FixedAssetCategoryForm}
          actions={actions}
          query={fixedAssetsCategories}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default FixedAssetsCategories;
